import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringBooleanValue } from 'workspaces/react-router-selectors';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ModalWithConfirmation from 'components/ModalWithConfirmation';
import { COPY_SPRAY_EVENT_MODAL } from '../../constants';
import SprayEventFinalForm from '../SprayEventFinalForm';

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps;

export class CopySprayEventModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [COPY_SPRAY_EVENT_MODAL]: undefined,
            sprayEventUuid: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <ModalWithConfirmation
                    size="fullscreen"
                    open={isOpen}
                    centered={false}
                    onCloseClick={this.handleClose}
                    closeIcon
                    className="spray-event-modal"
                    showConfirmation
                >
                    <ErrorBoundary
                        namespace="copySprayEventModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <SprayEventFinalForm title="Duplicate Spray Schedule" />
                    </ErrorBoundary>
                </ModalWithConfirmation>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(COPY_SPRAY_EVENT_MODAL)
});

export default connect(mapStateToProps, {
    updateQueryString
})(CopySprayEventModalComponent);
